import React from 'react';

import { InfoPageWrapper } from '../../shared/infoPageWrapper';
import MaxWidth from '../../shared/MaxWidth';
import * as S from './Privacy.styles';

export function PrivacyPageContent(props: { html: string | null }): React.ReactElement {
  return (
    <InfoPageWrapper>
      <MaxWidth>
        <S.Content>
          <S.TextBox>
            <S.Caption>Privacy Policy</S.Caption>
            <S.Text dangerouslySetInnerHTML={{ __html: props.html }} />
          </S.TextBox>
        </S.Content>
      </MaxWidth>
    </InfoPageWrapper>
  );
}
